import { styledThemed as styled } from "../theme";

export const VerticalSpace = styled.div<{ amount: number }>`
  height: ${(p) => p.theme.presentation.spacing(p.amount)};
`;
